import { getOmitPropertyFromIfThenFalse } from './getOmitPropertyFromIfThenFalse'
import { ifConditionMatches } from './ifConditionMatches'

/**
 * Applies allOf: unconditional required, conditional then (required + const),
 * then: false → omit that property when if matches, and
 * then.properties[key]: false → delete that key from the payload when if matches.
 */
export function applyAllOf(params, allOf, properties) {
  const result = { ...params }
  const omitWhenMatch = new Set()

  const allOfArray = allOf || []
  allOfArray.forEach((entry) => {
    const ifSchema = entry.if
    const then = entry.then

    if (!ifSchema) {
      const requiredArray = entry.required || []
      requiredArray.forEach((key) => {
        if (result[key] === undefined && properties?.[key]?.default !== undefined) {
          result[key] = properties[key].default
        }
      })

      return
    }

    if (then === false) {
      const omitKey = getOmitPropertyFromIfThenFalse(entry)
      if (omitKey && ifConditionMatches(ifSchema, result)) {
        omitWhenMatch.add(omitKey)
      }

      return
    }

    if (!ifConditionMatches(ifSchema, result)) {
      return
    }

    if (then?.required) {
      then.required.forEach((key) => {
        if (result[key] === undefined && properties?.[key]?.default !== undefined) {
          result[key] = properties[key].default
        }
      })
    }

    if (then?.properties) {
      Object.entries(then.properties).forEach(([key, subSchema]) => {
        if (subSchema === false) {
          delete result[key]

          return
        }

        if (subSchema?.const !== undefined) {
          result[key] = subSchema.const
        }
      })
    }
  })

  Array.from(omitWhenMatch).forEach((key) => {
    delete result[key]
  })

  return result
}
